import { ThunkAction } from '../store/shared/types';
import { OktaAuth } from '@okta/okta-auth-js';

export const logout = (auth: OktaAuth): ThunkAction<void> => async () => {
  await auth.signOut();
};
